import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wwu-aws',
  templateUrl: './aws.component.html',
  styleUrls: ['./aws.component.scss']
})
export class AwsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
